/**
 * Coup de pouce — Attendus 1101 « connaitre et reconnaitre les carrés
 * parfaits des entiers de 0 à 12 » (Puissances, l. 675) et 1105 « donner les
 * carrés des entiers de 0 à 12 » (Racine carrée, l. 691). UNE page STATIQUE,
 * les deux sens sur la même figure, partagée par toutes les clés des deux
 * ids (gen_1101 porte les deux jeux de clés, gen_1105 les clés donner_*).
 *
 * L'image que l'élève a déjà : la grille d'aire de 1047 (7 × 8 = 7 × 7 + 7)
 * et le carré 10 × 10 de 1059 (« m², c'est m × m »). Une grille 13 × 13 en
 * bleu, le côté 13 écrit deux fois ; le résultat en gros « 13² = 13 × 13 =
 * 169 » ; une ligne du sens direct en langue d'élève : « 13², c'est 13
 * rangées de 13. » ; le retour en orange, le sens inverse (mise en œuvre
 * Eduscol 2026 p. 17 : « je cherche le nombre qui, multiplié par lui-même,
 * donne 81 ») : « 169, c'est 13 × 13 : c'est le carré de 13. »
 *
 * EXEMPLE HORS PLAGE : 13² = 169. Les cartes vont de 0 à 12 : rien à
 * sacrifier, aucun des treize faits à connaître n'est perdu (choix mode
 * auto, À ARBITRER contre 6² = 36 sacrifié). Après l'aide, il reste 7 × 7 à
 * calculer (règle 9 : une fiche se défend). La grille est réduite (13 cases
 * de 11 px) : on la lit, on ne compte pas.
 */

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const BLEU_CLAIR = '#DBEAFE';
const ENCRE = '#1E293B';

const N = 13;
const CELL = 11;
const X0 = 128;
const Y0 = 40;
const COTE = N * CELL;

const GRILLE = [
    ...Array.from({ length: N + 1 }, (_, k) => `<line x1="${X0 + k * CELL}" y1="${Y0}" x2="${X0 + k * CELL}" y2="${Y0 + COTE}" stroke="${BLEU}" stroke-width="${k === 0 || k === N ? 1.6 : 0.6}"/>`),
    ...Array.from({ length: N + 1 }, (_, k) => `<line x1="${X0}" y1="${Y0 + k * CELL}" x2="${X0 + COTE}" y2="${Y0 + k * CELL}" stroke="${BLEU}" stroke-width="${k === 0 || k === N ? 1.6 : 0.6}"/>`),
].join('\n  ');

const SVG_GRILLE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="Une grille carrée bleue de 13 cases sur 13, le côté 13 écrit en haut et à gauche. 13 au carré égale 13 fois 13 égale 169. 13 au carré, c'est 13 rangées de 13. 169, c'est 13 fois 13 : c'est le carré de 13.">
  <rect x="${X0}" y="${Y0}" width="${COTE}" height="${COTE}" fill="${BLEU_CLAIR}"/>
  ${GRILLE}
  <text x="${X0 + COTE / 2}" y="${Y0 - 10}" font-size="13" font-weight="bold" text-anchor="middle" fill="${BLEU}">13</text>
  <text x="${X0 - 10}" y="${Y0 + COTE / 2 + 5}" font-size="13" font-weight="bold" text-anchor="end" fill="${BLEU}">13</text>

  <!-- le résultat, sens direct -->
  <text x="200" y="${Y0 + COTE + 40}" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${BLEU}">13</tspan>² = <tspan fill="${BLEU}">13 × 13</tspan> = 169</text>
  <text x="200" y="${Y0 + COTE + 66}" font-size="12" text-anchor="middle" fill="${ENCRE}"><tspan font-weight="bold" fill="${BLEU}">13²</tspan>, c'est 13 rangées de 13.</text>

  <!-- le retour, sens inverse -->
  <text x="200" y="${Y0 + COTE + 96}" font-size="12" text-anchor="middle" fill="${ENCRE}"><tspan font-weight="bold" fill="${ORANGE}">169</tspan>, c'est 13 × 13 : c'est <tspan font-weight="bold" fill="${ORANGE}">le carré de 13</tspan>.</text>
</svg>`.trim();

const AIDE = { pages: [{ titre: '13 rangées de 13', svg: SVG_GRILLE }] };

const CP_1101 = {
    reconnaitre_texte_trou_saisie: AIDE,
    reconnaitre_qcm_unique: AIDE,
    parfaits_qcm_multiple: AIDE,
    parfait_tableau_vf: AIDE,
    donner_texte_trou_saisie: AIDE,
    donner_qcm_unique: AIDE,
};

export default CP_1101;
